export default "__VITE_ASSET__Du4g_u3Q__"